import {useMutation, UseMutationResult, UseMutationOptions, useQueryClient} from '@tanstack/react-query';
import {toast} from 'react-toastify';
import {useTranslation} from 'react-i18next';
import {QUERY_KEYS} from '../../../../utils/queryKeys';
import {AIPresentationMetaData} from '../../../../incase-domain/AIPresentationMetaData';
import {generateAIPresentation} from '../../../../service/presentation';

type MutationOptions = UseMutationOptions<{_id: string; name: string}, unknown, AIPresentationMetaData>;

export const useGenerateAIPresentation = (
    options?: MutationOptions
): UseMutationResult<{_id: string; name: string}, unknown, AIPresentationMetaData> => {
    const {t} = useTranslation();
    const client = useQueryClient();

    return useMutation({
        mutationFn: (data: AIPresentationMetaData) => generateAIPresentation(data),
        onSuccess: () => {
            client.invalidateQueries({queryKey: QUERY_KEYS.presentation.lists()});
            toast.success(t('aiGeneratePresentation.generatedSuccess'));
        },
        onError: () => {
            toast.error(t('aiGeneratePresentation.generationError'));
        },
        ...options,
    });
};
